import { defineMessages } from 'react-intl';

export const HardwaresStepContent = defineMessages({
  title: {
    id: 'app.HardwaresStepContent.title',
    defaultMessage: 'Vyplň sériová čísla osazeného hardware',
  },
  serialNumberRequired: {
    id: 'app.HardwaresStepContent.serialNumberRequired',
    defaultMessage: 'Vyplňte sériové číslo',
  },
  noPairedHardware: {
    id: 'app.HardwaresStepContent.noPairedHardware',
    defaultMessage: 'Pro tento měřící bod nebyl napárovaný žádný hardware',
  },
});

export const HardwaresStepFooter = defineMessages({
  tooltip: {
    id: 'app.common.allFieldsRequired',
    defaultMessage: 'Pro pokračování je třeba vyplnit všechna povinná pole!',
  },
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
});
